import * as views from "../../views";
import * as models from "../../models";

/** @module Controller */

/**
 * @class
 * Maintains models and views instances
 */
export class Controller {
  views = views;
  models = models;
}
